export default [
  {
    section: 'training',
    name: 'Разминка',
    id: 0,
  },
  {
    section: 'passerine',
    name: 'Воробьиные',
    id: 1,
  },
  {
    section: 'forestbirds',
    name: 'Лесные птицы',
    id: 2,
  },
  {
    section: 'songbirds',
    name: 'Певчие птицы',
    id: 3,
  },
  {
    section: 'predatorbirds',
    name: 'Хищные птицы',
    id: 4,
  },
  {
    section: 'seabirds',
    name: 'Морские птицы',
    id: 5,
  },
];
